import { Component, Input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Patient } from '../../core/models/patient.model';
import { AgePipe } from '../../core/pipes/age.pipe';

@Component({
  selector: 'app-patient-personal-details',
  imports: [DatePipe, AgePipe],
  templateUrl: './patient-personal-details.html',
  styleUrl: './patient-personal-details.scss',
})
export class PatientPersonalDetails {
  @Input() patient: Patient | null | undefined;
}
